import { createFileRoute, redirect } from "@tanstack/react-router";
import { withQuery } from "@/lib/redirect-query";

// /denver-post-ops/ was renamed to /denver-post-op/ to match the original
// WordPress slug. Redirect legacy links (and the cached old URL) permanently.
export const Route = createFileRoute("/denver-post-ops")({
  beforeLoad: ({ location }) => {
    throw redirect({ href: withQuery("/denver-post-op/", location.searchStr), statusCode: 301 });
  },
});
